export default __webpack_public_path__ + "static/vector-section4-object-407f8242a35673bf1a6e37c7b512a665.webp";